import React from "react";
import "@/App.css";
import "@/i18n";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/context/AuthContext";
import PublicLayout from "@/layout/PublicLayout";
import ProtectedRoute from "@/layout/ProtectedRoute";

import Home from "@/pages/Home";
import ForParents from "@/pages/ForParents";
import ForEducators from "@/pages/ForEducators";
import About from "@/pages/About";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import ParentDashboard from "@/pages/ParentDashboard";
import EducatorDashboard from "@/pages/EducatorDashboard";
import AIMatch from "@/pages/AIMatch";
import EducatorsList from "@/pages/EducatorsList";
import EducatorProfile from "@/pages/EducatorProfile";
import PaymentResult from "@/pages/PaymentResult";
import LegalDoc from "@/pages/LegalDoc";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminKPIs from "@/pages/AdminKPIs";
import Messages from "@/pages/Messages";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route element={<PublicLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/parents" element={<ForParents />} />
            <Route path="/educators" element={<ForEducators />} />
            <Route path="/educators-list" element={<EducatorsList />} />
            <Route path="/educators-list/:id" element={<EducatorProfile />} />
            <Route path="/payment/result" element={<PaymentResult />} />
            <Route
              path="/messages"
              element={
                <ProtectedRoute>
                  <Messages />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/kpis"
              element={
                <ProtectedRoute>
                  <AdminKPIs />
                </ProtectedRoute>
              }
            />
            <Route
              path="/legal/parents"
              element={
                <ProtectedRoute role="parent">
                  <LegalDoc role="parent" />
                </ProtectedRoute>
              }
            />
            <Route
              path="/legal/educators"
              element={
                <ProtectedRoute role="educator">
                  <LegalDoc role="educator" />
                </ProtectedRoute>
              }
            />
            <Route path="/about" element={<About />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard/parent"
              element={
                <ProtectedRoute role="parent">
                  <ParentDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard/educator"
              element={
                <ProtectedRoute role="educator">
                  <EducatorDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/match"
              element={
                <ProtectedRoute role="parent">
                  <AIMatch />
                </ProtectedRoute>
              }
            />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
